export default {
    namespaced: true,
    state: {
        obj: {},
        objs: [],
    },
    mutations: {
        setObj(state, pload) {
            state.obj = pload
        },
        setObjs(state, pload) {
            state.objs = pload
        },
    },
    actions: {
        getObjs({rootState, commit}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}mass-production`
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        commit('setObjs', response.data.data)
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    })
            })
        },
        getObj({rootState, commit}, {code}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}mass-production/${code}`
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        commit('setObj', response.data.data)
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    })
            })
        },
        getDataFromPO({rootState}, {date}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}mass-production/data-from-po?date=${date}`;
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    })
            })
        },
        save({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "mass-production"
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            });
        }
    }
}